module.exports = __webpack_public_path__ + "img/avatar-gender-m-n.ec815d7a.png";